var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-3" }, [
    _c("div", { staticClass: "col" }),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-7" }, [
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", [
            _c("th"),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.T.tableHeaderMonthly[_vm.lang]))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.T.tableHeaderYearly[_vm.lang]))])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          { attrs: { id: "adoTable" } },
          _vm._l(_vm.rows, function(row) {
            return _c("tr", { key: row.title }, [
              _c("td", { style: row.style }),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(row.title))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.format.format(row.value)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.format.format(row.value * 12)))
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c("td", [_vm._v("∑")]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.T.totalCost[_vm.lang]) + ":")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.format.format(_vm.sum)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.format.format(_vm.sum * 12)))
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td"),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.T.szjaOnePercent[_vm.lang]))]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.format.format(
                    Math.round(_vm.rows[_vm.SZJA_INDEX].value * 12 * 0.01)
                  )
                )
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db2303d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db2303d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/TaxTable.vue
// module id = 28
// module chunks = 0